import { render } from "@/share/components/controls/svgButton/SVGButton.html?vue&type=template&id=d4189bdc&scoped=true&external"
import script from "@/share/components/controls/svgButton/SVGButton.js?vue&type=script&lang=js&external"
export * from "@/share/components/controls/svgButton/SVGButton.js?vue&type=script&lang=js&external"

import "@/share/components/controls/svgButton/SVGButton.scss?vue&type=style&index=0&id=d4189bdc&lang=scss&scoped=true&external"

import exportComponent from "../../../../execute/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4189bdc"]])

export default __exports__